import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { useAsObservableSource } from 'mobx-react-lite';
import { observer } from 'src/utils/mobx-react';
import { PriceHistory } from 'src/domains/sportsbook/webview/components/priceHistory/PriceHistory';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import { TrapListItem } from 'src/domains/sportsbook/webview/components/raceSummary/RaceSummaryRow.style';
import { RaceSummaryRow } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/RaceSummary.style';
import {
    SpInProgress,
    WinInProgress,
} from 'src/domains/sportsbook/webview/components/selectionRaceCard/SelectionRaceCard.style';
import { AntePostAndSpecials } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummaryRowSport/AntePostAndSpecials/AntePostAndSepcials';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import {
    CellRunner,
    GreyhoundAndTrainerDetailsBox,
    PriceHistoryCell,
    RaceCardTrap,
    UnnamedFavouriteLabel,
} from 'src/domains/sportsbook/webview/components/raceSummary/raceSummaryRowSport/greyhoundRacing/RaceSummaryRowGreyhoundRacing.style';

interface PropsType {
    antePost: boolean;
    className?: string;
    dataTest?: string;
    isNonRunner?: boolean;
    isPriceHistoryHidden: boolean;
    isRaceInProgress?: boolean;
    isUnnamedFavourite: boolean;
    runner?: React.ReactNode;
    selectionId: SelectionId;
    sp?: React.ReactNode;
    trapChallengeTag: string | undefined;
    winner?: React.ReactNode;
}

export const RaceSummaryRowGreyhoundRacing = observer(
    'RaceSummaryRowGreyhoundRacing',
    (propsIn: PropsType): JSX.Element => {
        const props = useAsObservableSource(propsIn);
        const {
            antePost,
            className,
            dataTest,
            isNonRunner,
            isPriceHistoryHidden,
            isRaceInProgress,
            isUnnamedFavourite,
            runner,
            selectionId,
            sp,
            trapChallengeTag,
            winner,
        } = props;

        const common = useCommon();
        const configState = ConfigComponents.get(common).config;
        const { sportsbookVariant } = configState.componentVariants;

        const selectionModel = selectionId.getModel();
        const trapChallenge = trapChallengeTag === 'yes';

        if (isUnnamedFavourite) {
            return (
                <RaceSummaryRow
                    className={className}
                    isNonRunner={isNonRunner}
                    data-test={dataTest}
                    variant={sportsbookVariant}
                >
                    <UnnamedFavouriteLabel isAntePost={antePost}>{runner}</UnnamedFavouriteLabel>
                    {isRaceInProgress === true ? <SpInProgress variant={sportsbookVariant} /> : sp}
                </RaceSummaryRow>
            );
        } else if (antePost) {
            return (
                <AntePostAndSpecials
                    selectionId={selectionId}
                    winner={winner}
                />
            );
        } else if (trapChallenge) {
            return (
                <TrapListItem
                    className={className}
                    variant={sportsbookVariant}
                >
                    {isRaceInProgress === true ? <WinInProgress variant={sportsbookVariant} /> : winner}
                </TrapListItem>
            );
        } else {
            return (
                <RaceSummaryRow
                    className={className}
                    isNonRunner={isNonRunner}
                    data-test={dataTest}
                    variant={sportsbookVariant}
                >
                    <CellRunner>
                        <RaceCardTrap
                            trapNumber={selectionModel === null ? null : selectionModel.metaDataNumber}
                            selectionId={selectionId}
                        />

                        <GreyhoundAndTrainerDetailsBox
                            selectionId={selectionId}
                            isDetailsAvailable={false}
                        />
                    </CellRunner>

                    {isPriceHistoryHidden ? null : (
                        <PriceHistoryCell variant={sportsbookVariant}>
                            <PriceHistory selectionId={selectionId} />
                        </PriceHistoryCell>
                    )}

                    {isRaceInProgress === true ? <WinInProgress variant={sportsbookVariant} /> : winner}
                    {isRaceInProgress === true ? <SpInProgress variant={sportsbookVariant} /> : sp}
                </RaceSummaryRow>
            );
        }
    }
);
